import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getSwapAllTokens, getSwapAllTokensSearch } from '../../api';

export const useSwapAllTokens = () => {
  return useQuery({
    queryKey: ['getSwapAllTokens'],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const res = await getSwapAllTokens();
      return res;
    },
  });
};

export const useSwapAllTokensSearch = ({
  chain,
  content,
  config,
}: {
  chain?: string;
  content: string;
  config: { url: string; tmaid: string; tmakey: string };
}) => {
  return useQuery({
    queryKey: ['getSwapAllTokensV2Search', chain, content, config],
    queryFn: async () => {
      const res = await getSwapAllTokensSearch(
        {
          content,
          chain: chain,
        },
        config
      );
      return res;
    },
  });
};
